import React from 'react';
import { Price } from './price';
export { getPrice, getPriceValue, getPlanName } from './price';
export default React.memo(Price);
